import {
  fetchAreaPrefecturesMap,
  fetchIndustries,
  fetchInterests,
  fetchLanguages,
  fetchOccupations,
  fetchProgramTypes,
  fetchQualifications,
  fetchSchools,
  fetchSkills,
} from '@/util/ref'
import { fetchSysConfig } from '@/util/sys'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

export default function usePrefetchAfterLogin(isLoggedIn: boolean) {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!isLoggedIn) return

    queryClient.prefetchQuery({
      queryKey: ['area-prefecture'],
      queryFn: fetchAreaPrefecturesMap,
      staleTime: Infinity,
    })

    queryClient.prefetchQuery({
      queryKey: ['industry'],
      queryFn: fetchIndustries,
      staleTime: 1000 * 60 * 5,
    })

    queryClient.prefetchQuery({
      queryKey: ['interest'],
      queryFn: fetchInterests,
      staleTime: 1000 * 60 * 5,
    })

    queryClient.prefetchQuery({
      queryKey: ['language'],
      queryFn: fetchLanguages,
      staleTime: 1000 * 60 * 5,
    })

    queryClient.prefetchQuery({
      queryKey: ['occupation'],
      queryFn: fetchOccupations,
      staleTime: 1000 * 60 * 5,
    })

    queryClient.prefetchQuery({
      queryKey: ['program-type'],
      queryFn: fetchProgramTypes,
      staleTime: 1000 * 60 * 5,
    })

    queryClient.prefetchQuery({
      queryKey: ['qualification'],
      queryFn: fetchQualifications,
      staleTime: 1000 * 60 * 5,
    })

    queryClient.prefetchQuery({
      queryKey: ['school'],
      queryFn: fetchSchools,
      staleTime: 1000 * 60 * 5,
    })

    queryClient.prefetchQuery({
      queryKey: ['skill'],
      queryFn: fetchSkills,
      staleTime: 1000 * 60 * 5,
    })

    queryClient.prefetchQuery({
      queryKey: ['sys-config'],
      queryFn: fetchSysConfig,
      staleTime: 1000 * 60 * 5,
    })
  }, [isLoggedIn, queryClient])
}
